import {
  Button,
  HStack,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { DiskContext } from '../../context';
import { getUserFullName } from 'v4/lib/commons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const RevokeSharedDiskModal = forwardRef(({ ...props }, ref) => {
  const {
    selectedFile,
    revokeSharedDiskUser,
    revokeSharedDiskUserDisc,
    revokeSharedDiskUserLoading,
  } = useContext(DiskContext);
  const { t } = useTranslator();

  return (
    <>
      <Modal {...revokeSharedDiskUserDisc}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader>
            <HStack alignItems={'flex-start'}>
              <Stack spacing={0} gap={0}>
                <Heading size="md">{t('profile.remove') || "Remove"}</Heading>
              </Stack>
            </HStack>
          </ModalHeader>
          <ModalBody>
            <Text>
              {t('otherModules.youWillLoseAccessTo') || "You'll lose access to"} {getUserFullName(selectedFile)}'s {t('settingsBilling.disk') || "disk"}
            </Text>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button
                onClick={revokeSharedDiskUserDisc?.onClose}
                variant="secondary"
              >
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                onClick={(e) => revokeSharedDiskUser(selectedFile)}
                isLoading={revokeSharedDiskUserLoading}
                type="submit"
                variant="primary"
              >
                {t('profile.remove') || "Remove"}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
});
